/* eslint-disable import/no-unresolved */
import { Reducer } from "redux";
import { bindLoanDetailsAPIData } from "src/helpers/FormDetails";
import { initialValues } from "src/helpers/FormDetails/LoanDetails";
import {
  SAVE_LOAN_DETAILS,
  SET_LOAN_DETAILS,
  TOGGLE_RIDER_FORM,
  SET_RIDER_SELECTION_LOCKED
} from "src/redux/Types/loanDetails";
import { ILoanDetails } from "./interface";

const initialState: ILoanDetails = {
  ...initialValues,
  applicationId: "",
  isRiderSelectionLocked: false
};

// eslint-disable-next-line default-param-last
const loanDetailsReducer: Reducer<ILoanDetails> = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_LOAN_DETAILS: {
      const data = bindLoanDetailsAPIData(
        state,
        action.payload.apiData,
        action.payload.masterData,
        action?.payload?.riderMaster
      );
      return { ...state, ...data, applicationId: action.payload.leadId };
    }
    case SET_LOAN_DETAILS: {
      return { ...state, ...action.payload };
    }
    case TOGGLE_RIDER_FORM: {
      return { ...state, showRiderForm: action.payload };
    }
    case SET_RIDER_SELECTION_LOCKED: {
      return { ...state, isRiderSelectionLocked: action.payload };
    }

    default:
      return state;
  }
};

export default loanDetailsReducer;
